import React, {
  Component,
  // createRef,
} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
// import { CupertinoPane } from 'cupertino-pane'
// import { Loader }  from 'src/components/Loader'
// import {
//   getKioskWindow,
//   isTouchDevice,
//   logError,
// } from 'src/utils/helpers'
import './SlideOverPane.less'
import styles from './SlideOverPane.module.less'

class SlideOverPane extends Component {
  state = {
    isFallbackVisible: false,
    // isSlidingPaneContentLoading: false,
  }

  // constructor(props) {
  //   super(props)
  //
  //   this.windowResizeTimeout = null
  //   this.window = getKioskWindow()
  //
  //   this.slidingPaneRef = createRef()
  //   this.slidingPaneInstance = null
  //
  //   this.containerHeight = this.getRefHeight(props.containerRef)
  // }

  // componentDidMount() {
  //   // Listen to the window resize event to update slide over pane
  //   this.window.addEventListener('resize', this.onWindowResize)
  //
  //   this.initPane()
  // }
  //
  // componentWillUnmount() {
  //   this.window.removeEventListener('resize', this.onWindowResize)
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.isVisible !== this.props.isVisible) {
      if (!this.props.isVisible) {
        this.closeSlideOverPane()
      }
    }
  }

  // onWindowResize = () => {
  //   const { containerRef } = this.props
  //   const me = this
  //   try {
  //     if (this.windowResizeTimeout) {
  //       clearTimeout(this.windowResizeTimeout)
  //     }
  //
  //     // Run with 200ms delay
  //     this.windowResizeTimeout = setTimeout(() => {
  //       this.containerHeight = this.getRefHeight(containerRef)
  //       me.initPane()
  //       me.forceUpdate()
  //     }, 200)
  //   } catch (e) {
  //     logError('On window resize in slide over pane', e, 0)
  //   }
  // }

  /**
   * Get height of referenced DOM element.
   *
   * @param ref For which DOM element to get the height
   * @return {number}
   */
  // getRefHeight = (ref) => {
  //   try {
  //     if(ref && ref.current) {
  //       return parseInt(ref.current.offsetHeight)
  //     }
  //     return 0
  //   } catch (e) {
  //     return 0
  //   }
  // }

  /**
   * Check if we should use simpler list ("modal").
   *
   * `cupertino-pane` package doesn't work in widget and it's pretty bad for non-touch devices.
   *
   * @return {boolean}
   */
  shouldUseFallback = () => {
    // TODO: PAT-2318 Find some other slide over panel or create something from scratch
    //  for example:
    //  https://www.npmjs.com/package/rn-sliding-up-panel
    //  https://www.npmjs.com/package/react-native-swipe-up-down

    return true

    // if(this.props.isWidget) {
    //   return true
    // }
    //
    // if(window.screen.width >= 992 || window.screen.height <= 400 || this.containerHeight <= 100) {
    //   return true
    // }
    //
    // return !isTouchDevice()
  }

  showFallback = () => {
    this.setState({
      isFallbackVisible: true,
    })
  }

  hideFallback = () => {
    this.setState({
      isFallbackVisible: false,
    })
  }

  openSlideOverPane = () => {
    this.showFallback()

    // if(this.slidingPaneInstance && typeof this.slidingPaneInstance.moveToBreak === "function") {
    //   this.slidingPaneInstance.moveToBreak('top')
    // }
  }

  closeSlideOverPane = () => {
    this.hideFallback()

    // if(this.slidingPaneInstance && typeof this.slidingPaneInstance.moveToBreak === "function") {
    //   this.slidingPaneInstance.moveToBreak('bottom')
    // }
  }

  /* initPane = () => {
    if(this.shouldUseFallback()) {
      return false
    }

    if(!(this.slidingPaneRef && this.slidingPaneRef.current)) {
      return false
    }

    if(this.slidingPaneInstance) {
      this.slidingPaneInstance.destroy()
    }

    const {
      isVisible,
      onAfterLoad,
    } = this.props

    const containerHeight = this.containerHeight

    const headerHeight = 76
    const breakpointTop = containerHeight - 8
    // Use up more space for the slide over pane on bigger screens
    const heightRatio = containerHeight > 724 ? 0.6 : 0.4
    const breakpointMiddle = containerHeight > 0 ? Math.round(containerHeight * heightRatio) : 360
    // We need to keep a bit more space so that you don't exit out of iOS standalone app
    const breakpointBottom = 58

    const useMiddleBreak = containerHeight > 590

    let breaks = {
      top:    { enabled: true, height: breakpointTop },
      bottom: { enabled: true, height: breakpointBottom }
    }

    if(useMiddleBreak) {
      breaks.middle = { enabled: true, height: breakpointMiddle }
    }

    const initialBreak = isVisible && useMiddleBreak ? 'middle' : 'bottom'

    this.slidingPaneInstance = new CupertinoPane(this.slidingPaneRef.current, {
      breaks: breaks,
      initialBreak: initialBreak,
      buttonClose: false,
      lowerThanBottom: false,
      simulateTouch: false,
      preventClicks: false,
      bottomOffset: headerHeight,
      onTransitionEnd: () => {
        try {
          // Dirty hack to wait for sliding pane to be loaded at the top and scrollable
          if (this.slidingPaneInstance.currentBreak() === 'top') {
            this.setState({
              isSlidingPaneContentLoading: true,
            }, () => {
              setTimeout(() => {
                this.setState({
                  isSlidingPaneContentLoading: false,
                })
              }, 1500)
            })
          }
        } catch (e) {
          logError('Sliding pane transition ended', e, 0)
        }
      }
    })

    this.slidingPaneInstance.present({
      animate: true,
    })

    if(initialBreak === 'middle') {
      // To the center of the full screen (half of container height)
      const fullHeightMiddle = containerHeight / 2
      // What's left and not covered by this sliding pane (visible part of the map in google map example)
      const usableHeight = containerHeight - breakpointMiddle
      // To the center of the sliding pane (half of usable height)
      const usableMiddle = usableHeight / 2

      // Difference between center of the screen and center of usable space (part not covered by this sliding pane)
      const usableCenter = fullHeightMiddle - usableMiddle

      onAfterLoad(Math.round(usableCenter))
    }
  }*/

  /**
   * Prepare callback data to be used in child components (which are wrapped by this component).
   *
   * For example, to close open or close this slide-over pane.
   *
   * @returns {object}
   */
  passToChildren = () => ({
    isSlideOverPaneFallbackVisible: this.state.isFallbackVisible,
    openSlideOverPane: this.openSlideOverPane,
    closeSlideOverPane: this.closeSlideOverPane,
  })

  /**
   * Support both component and a function as children.
   *
   * It needs to be a function when we want to use
   *
   * @return {mixed}
   */
  renderChildren = () => {
    const { children } = this.props

    if (typeof children === 'function') {
      // Pass state or functions to be used in child components
      return children(this.passToChildren())
    }

    return children || ''
  }

  render() {
    const { fallbackTriggerShow, fallbackTriggerHide } = this.props
    const {
      isFallbackVisible,
      // isSlidingPaneContentLoading,
    } = this.state

    const isFallback = this.shouldUseFallback()
    const isFallbackTriggerShow = fallbackTriggerShow && typeof fallbackTriggerShow === 'function'
    const isFallbackTriggerHide = fallbackTriggerHide && typeof fallbackTriggerHide === 'function'

    // Exit if we need to use fallback but fallback triggers were not defined
    if (isFallback && !(isFallbackTriggerShow && isFallbackTriggerHide)) {
      return ''
    }

    // if(isFallback) {
    return (
      <div>
        {isFallbackVisible && (
          <div
            className={cx({
              [styles.fallbackContent]: true,
              'kiosk--chakra-colors-background': true,
            })}
          >
            {this.renderChildren()}
          </div>
        )}

        <div className={styles.fallbackTriggersHolder}>
          {isFallbackTriggerShow && isFallbackVisible === false ? (
            <span onClick={this.showFallback}>{fallbackTriggerShow()}</span>
          ) : (
            ''
          )}
          {isFallbackTriggerHide && isFallbackVisible === true ? (
            <span onClick={this.hideFallback}>{fallbackTriggerHide()}</span>
          ) : (
            ''
          )}
        </div>
      </div>
    )
    // }

    // return (
    //   <div ref={this.slidingPaneRef}>
    //     {isSlidingPaneContentLoading && (
    //       <Loader className={styles.slidingPaneContentLoading}/>
    //     )}
    //     {this.renderChildren()}
    //   </div>
    // )
  }
}

SlideOverPane.propTypes = {
  onAfterLoad: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  isWidget: PropTypes.bool,
  fallbackTriggerShow: PropTypes.func,
  fallbackTriggerHide: PropTypes.func,
}

SlideOverPane.defaultProps = {
  isWidget: false,
  isVisible: false,
}

export default SlideOverPane
